import { Card, Col, Row, Tag } from "rsuite";
import type { FlightArrivalComponentProps } from "../my-type";
import { AirplaneFill } from "react-bootstrap-icons";
import { useGetAirlines } from "../hooks/Airline";
import { useEffect, useState } from "react";


export default function FlightArrivalComponent({ flightArrival }: FlightArrivalComponentProps) {
  const { airlines } = useGetAirlines();
  const [airlineName, setAirlineName] = useState<string | undefined>(undefined);

  useEffect(() => {
    let airline = airlines.find(element => element.airlineID === flightArrival.airlineID);
    if (airline) {
      if (airline.airlineName.zh_tw) {
        setAirlineName(airline.airlineName.zh_tw);
      } else {
        setAirlineName(airline.airlineName.en);
      }
    }


  }, [])

  return (<div style={{ paddingLeft: '10px', paddingRight: '10px', width: '100%' }}>
    <Card size="sm">
      <Card.Body>
        <Row>
          <Col xs={2}><AirplaneFill /></Col>
          <Col xs={16} style={{ textAlign: 'left' }}>{airlineName}<br></br>{flightArrival.airlineID}{flightArrival.flightNumber}</Col>
          <Col xs={6} style={{ textAlign: 'right' }}>航廈T{flightArrival.terminal}<br></br>登機門{flightArrival.gate}</Col>
        </Row>
        <Row>
          <Col xs={2}></Col>
          {flightArrival.arrivalRemark.indexOf("ARRIVED") === -1 ?
            <Col xs={16} style={{ textAlign: 'left' }}>
              預定:{flightArrival.scheduleArrivalTime.split('T')[1]}&nbsp;
              預估:{flightArrival.estimatedArrivalTime.split('T')[1]}<br></br>
              {flightArrival.arrivalAirportID}</Col>
            : <Col xs={16} style={{ textAlign: 'left' }}>
              抵達:{flightArrival.actualArrivalTime?.split('T')[1]}<br></br>
              {flightArrival.arrivalAirportID}
            </Col>}
          <Col xs={6} style={{ textAlign: 'right' }}><br></br><Tag>{flightArrival.arrivalRemark}</Tag></Col>
        </Row>
      </Card.Body>
    </Card>
  </div>)
}
